<div class="desposit-button" (click)="goToDeposit()">
    <span>{{ messages.deposit }}</span>
</div>
<div class="close-icon" (click)="onCancelClick()">
    <i class="close">
        <span>{{ messages.closeBetslip }}</span>
    </i>
</div>
